<script lang="ts">
import '@banno/jha-wc/src/buttons/jha-button/jha-button.js'
import {$inj, $injByInterface} from '@/common/decorators/depinject'
import REGEX from '@/common/enums/regexEnum'
import QuestionAnswerFactory from '@/common/services/Questionnaire/QuestionAnswerFactory'
import QuestionnaireFactory from '@/common/services/Questionnaire/QuestionnaireFactory'
import NotificationFactory from '@/common/services/notificationFactory'
import BltQuestionnaireFactory from '@/common/components/bltQuestionnaire/bltQuestionnaireFactory'
import {defineComponent} from 'vue'
import {StatusType, QuestionType} from '@/common/constant/BltQuestionnaireConstant'
import {DialogConstant} from '@/common/constant/DialogConstant'
import '@banno/jha-wc/src/forms/jha-form-date-input-icon/jha-form-date-input-icon.js'
import '@banno/jha-wc/src/forms/jha-form-radio-button/jha-form-radio-button.js'
import '@banno/jha-wc/src/forms/jha-form-text-input/jha-form-text-input.js'
import '@banno/jha-wc/src/forms/jha-form-checkbox/jha-form-checkbox.js'
import '@banno/jha-wc/src/forms/jha-form-currency-input/jha-form-currency-input.js'
import BltLookup from '@/common/components/bltLookup/bltLookup.vue'
import '@banno/jha-wc/src/icons/jha-icon-checkmark.js'
import {find, map} from 'lodash'
import type {Choice, Question, Questionnaire} from '@/common/components/bltQuestionnaire/cipTypes'
import {OpenLanguageKeysConstant} from '@/common/constant/OpenLanguageKeysConstant'
import type IWorkspaceStore from '@/common/services/Workspace/IWorkspaceStore'
import {ProductGuideConstant} from '@/common/constant/ProductGuideConstant'
import "@banno/jha-wc/src/jha-flex-wrapper/jha-flex-wrapper.js";
export default defineComponent({
  name: 'bltGenericQuesstionnaire',
  emits: ['successCallback'],
  components: {
    BltLookup
  },
  props: {
    enrollmentId: {
      type: Number
    },
    applicantId: {
      type: Number
    },
    uuid: {
      type: String,
      required: true
    },
    questionnaireType: {
      type: String
    },
    questionnaire: {
      type: Object as () => Questionnaire,
      required: true
    },
    scrollId: {
      type: String,
      default: ''
    }
  },
  setup() {
    const questionnaireFactory = $inj(QuestionnaireFactory)
    const questionAnswerFactory = $inj(QuestionAnswerFactory)
    const bltQuestionnaireFactory = $inj(BltQuestionnaireFactory)
    const notificationFactory = $inj(NotificationFactory)
    const workspaceStore = $injByInterface<IWorkspaceStore>('IWorkspaceStore')
    return {
      questionnaireFactory,
      questionAnswerFactory,
      notificationFactory,
      bltQuestionnaireFactory,
      workspaceStore
    }
  },
  created() {
    this.resource = this.enrollmentId ? ProductGuideConstant.ENROLLMENT : ProductGuideConstant.APPLICANT
    this.resourceId = this.enrollmentId || this.workspaceStore.applicant.applicantId
    this.questionnaireData = this.questionnaire
    this.load()
  },
  data() {
    return {
      integerPattern: REGEX.POSITIVE_INTEGER,
      currencyPattern: REGEX.CURRENCY,
      loading: true,
      answeringQuestion: false,
      previousQuestions: [] as Question[],
      currentQuestion: {} as Question,
      questionnaireData: {} as Questionnaire,
      resource: '' as string,
      resourceId: 0 as number,
      StatusType,
      QuestionType,
      showDialog: false,
      DialogConstant,
      editQuestion: {
        question: {} as Question,
        index: 0
      },
      InvalidErrorMessage: ''
    }
  },
  methods: {
    checkInputValidation(currentQuestion: Question) {
      this.InvalidErrorMessage = this.integerPattern.test(currentQuestion.selectedAnswer)
        ? ''
        : OpenLanguageKeysConstant.NUMBER_VALIDATION_MESSAGE
    },
    onLookupChange(response: any, currentQuestion: Question) {
      currentQuestion.selectedAnswer = response
    },
    editPreviousQuestion(question: Question, index: number) {
      this.showDialog = true
      this.editQuestion.question = question
      this.editQuestion.index = index
    },
    getLookupSelectedAnswers(
      choices: {
        choiceText: string
      }[]
    ) {
      return map(choices, function (item) {
        return item.choiceText
      }).join(', ')
    },
    multiCheckboxSelect(
      detail: {
        checked: boolean
      },
      choice: Choice
    ) {
      choice.selected = detail.checked
    },
    inputChecked(evt: {
      detail: {
        value: {
          choiceId: number
        }
      }
    }) {
      this.currentQuestion.selectedAnswer = evt.detail.value.choiceId
    },
    next() {
      this.answeringQuestion = true
      this.questionAnswerFactory
        .save(
          this.uuid,
          this.resource,
          this.resourceId,
          this.questionnaireData.cddRequestId,
          this.currentQuestion.componentId,
          {
            cddRequestId: this.questionnaireData.cddRequestId as number,
            questionId: this.currentQuestion.componentId,
            answers: this.bltQuestionnaireFactory.getAnswer(this.currentQuestion)
          }
        )
        .then((response) => {
          this.previousQuestions.push(response.previousQuestions[0])
          this.questionnaireData.status = response.status
          this.currentQuestion = response.question
          this.$emit('successCallback', this.questionnaireData)
        })
        .finally(() => {
          this.answeringQuestion = false
        })
    },
    onConfirmEditQuestion() {
      this.notificationFactory.clearMessages()
      this.questionnaireData.status = StatusType.INPROGRESS
      this.showDialog = false
      this.previousQuestions.length = this.editQuestion.index
      this.currentQuestion = this.editQuestion.question
    },
    load() {
      this.questionnaireFactory
        .getAll(this.uuid, this.resource, this.resourceId, 0, {questionnaireType: this.questionnaireType as string})
        .then(async (response) => {
          const data =
            response.length === 0
              ? await this.questionnaireFactory.save(
                  this.uuid,
                  this.resource,
                  this.resourceId,
                  this.questionnaireData.cddRequestId,
                  {
                    questionnaireType: this.questionnaireType as string
                  }
                )
              : await this.questionnaireFactory.getAll(
                  this.uuid,
                  this.resource,
                  this.resourceId,
                  response[0].cddRequestId,
                  {questionnaireType: this.questionnaireType as string}
                )
          this.$emit('successCallback', data)
          this.questionnaireData = data
          this.previousQuestions = data.previousQuestions || []
          this.currentQuestion = this.questionnaireData.question
        })
        .finally(() => {
          this.loading = false
        })
    }
  },
  computed: {
    enableNextQuestion() {
      return this.currentQuestion.selectedAnswer || !!find(this.currentQuestion.choices, {selected: true})
    }
  }
})
</script>

<template>
  <form name="EnrollmentCIP">
    <div class="cip-ques">
      <div
        class="enroll-cip"
        v-for="(previousQuestion, index) in previousQuestions"
        :key="index">
        <div class="cip-question">Question {{ index + 1 }}: {{ previousQuestion.questionText }}</div>
        <div
          class="question-bank ques-ans"
          v-if="previousQuestion.questionType === QuestionType.SINGLE_CHOICE">
          <div
            class="cip-answer"
            v-for="(choice, index) in previousQuestion.choices"
            :key="index">
            <jha-icon-checkmark
              class="choice-icon secondary-fill-color"
              v-if="choice.choiceId == choice.answer" />
            <span
              class="choice-text"
              :class="{'selected-answer': choice.choiceId == choice.answer}">
              {{ choice.choiceText }}
            </span>
          </div>
        </div>

        <div
          class="question-bank ques-ans"
          v-if="previousQuestion.questionType === QuestionType.MULTI_CHOICE">
          <div
            class="cip-answer"
            v-for="(choice, index) in previousQuestion.choices"
            :key="index">
            <jha-flex-wrapper class="spacing-small">
              <jha-icon-checkmark
                class="choice-icon secondary-fill-color"
                v-if="choice.choiceId == choice.answer" />
              <span
                class="choice-text"
                :class="{'selected-answer': choice.choiceId == choice.answer}">
                {{ choice.choiceText }}
              </span>
            </jha-flex-wrapper>
          </div>
        </div>
        <div
          class="question-bank ques-ans"
          v-if="
            previousQuestion.questionType === QuestionType.TEXT ||
            previousQuestion.questionType === QuestionType.NUMBER ||
            previousQuestion.questionType === QuestionType.DATE ||
            previousQuestion.questionType === QuestionType.MONEY
          ">
          <div class="cip-questions cip-dropdown-ans">
            <span
              class="dollar-sign"
              v-if="previousQuestion.questionType === QuestionType.MONEY"
              >$
            </span>

            <span class="answer"> {{ previousQuestion.answer }}</span>
          </div>
        </div>

        <div
          class="question-bank ques-ans"
          v-if="
            previousQuestion.questionType === QuestionType.MULTI_CHOICE_LOOKUP ||
            previousQuestion.questionType === QuestionType.SINGLE_CHOICE_LOOKUP
          ">
          <div class="cip-questions cip-dropdown-ans">
            <span class="answer"> {{ getLookupSelectedAnswers(previousQuestion.choices) }}</span>
          </div>
        </div>

        <div class="edit-answer open mb-16">
          <jha-button
            sync
            link
            class="open"
            @click="editPreviousQuestion(previousQuestion, index)"
            :disabled="
              questionnaireData?.result === StatusType.REJECT || questionnaireData?.status === StatusType.COMPLETED
            ">
            Edit this answer
          </jha-button>
        </div>

        <div class="divider"></div>
      </div>

      <div
        class="enroll-cip"
        id="cdd-question-container"
        v-if="currentQuestion && currentQuestion.questionType">
        <div
          class="cip-question"
          id="current-cdd-question"
          v-if="questionnaireData.status === StatusType.INPROGRESS">
          Question {{ previousQuestions.length + 1 }}: {{ currentQuestion.questionText }}
        </div>
        <div
          class="question-bank"
          id="current-cdd-question"
          v-if="currentQuestion.questionType === QuestionType.SINGLE_CHOICE">
          <div
            class="cip-questions"
            v-for="(choice, index) in currentQuestion.choices"
            :key="index">           
             <jha-form-radio-button @checked="inputChecked" :checked="choice.choiceId === currentQuestion.selectedAnswer" :value="choice" :key="choice" :name="currentQuestion.componentId">
               {{ choice?.choiceText }}
            </jha-form-radio-button>
          </div>
        </div>

        <div
          class="question-bank"
          v-if="currentQuestion.questionType === QuestionType.MULTI_CHOICE">
          <div
            class="cip-questions"
            v-for="(choice, index) in currentQuestion.choices"
            :key="index">
            <jha-flex-wrapper class="spacing-small">
              <jha-form-checkbox
                style="width: 100%"
                class="checkbox-full-width"
                :key="choice.choiceId"
                :value="choice.choiceId"
                @change="multiCheckboxSelect($event.detail, choice)">
                {{ choice?.choiceText }}
              </jha-form-checkbox>
            </jha-flex-wrapper>
          </div>
        </div>
        <div
          class="question-bank"
          v-if="currentQuestion.questionType === QuestionType.TEXT">
          <div class="cip-questions cip-dropdown">
            <jha-form-text-input
              v-model="currentQuestion.selectedAnswer"
              outline
              label="Answer"
              required>
            </jha-form-text-input>
          </div>
        </div>
        <div
          class="question-bank"
          v-if="currentQuestion.questionType === QuestionType.NUMBER">
          <div class="cip-questions cip-dropdown">
            <jha-form-text-input
              v-model="currentQuestion.selectedAnswer"
              @change="checkInputValidation(currentQuestion)"
              :warning="InvalidErrorMessage"
              outline
              label="Answer"
              required>
            </jha-form-text-input>
          </div>
        </div>
        <div
          class="question-bank"
          v-if="currentQuestion.questionType === QuestionType.MONEY">
          <div class="cip-questions cip-dropdown">
            <jha-form-currency-input
              v-model="currentQuestion.selectedAnswer"
              outline
              required></jha-form-currency-input>
          </div>
        </div>

        <div
          class="question-bank"
          v-if="currentQuestion.questionType === QuestionType.DATE">
          <div class="cip-questions cip-dropdown">
            <jha-form-date-input-icon
              outline
              required
              name="date"
              ref="date"
              v-model="currentQuestion.selectedAnswer"></jha-form-date-input-icon>
          </div>
        </div>

        <div
          class="question-bank"
          v-if="currentQuestion.questionType === QuestionType.MULTI_CHOICE_LOOKUP">
          <div class="cip-questions cip-dropdown">
            <blt-lookup
              :lookup-url="currentQuestion.categoryUrl"
              :is-multi-choice="true"
              input-name="multiLookup"
              @onLookupChange="(response) => onLookupChange(response, currentQuestion)"
              :selected-lookup="currentQuestion.selectedAnswer"></blt-lookup>
          </div>
        </div>
        <div
          class="question-bank"
          v-if="currentQuestion.questionType === QuestionType.SINGLE_CHOICE_LOOKUP">
          <div class="cip-questions cip-dropdown">
            <blt-lookup
              :lookup-url="currentQuestion.categoryUrl"
              :is-multi-choice="false"
              input-name="multiLookup"
              @onLookupChange="(event) => onLookupChange(event[0], currentQuestion)"
              :selected-lookup="currentQuestion.selectedAnswer"></blt-lookup>
          </div>
        </div>
        <div class="divider"></div>
      </div>
    </div>
    <div class="right-align pr-24">
      <jha-button
        @click="next"
        sync
        :disabled="!enableNextQuestion"
        v-if="!questionnaireData.completed && questionnaireData.status == StatusType.INPROGRESS">
        Next question
      </jha-button>
    </div>
  </form>
  <blt-modal-dialog
    type="small-dialog"
    :clickOutsideToClose="true"
    :showDialog="showDialog"
    @cancel="showDialog = false"
    :title="DialogConstant.EDIT_QUESTION_DIALOG_TITLE">
    <template #dialog-content>
      <div class="dialog-content">
        {{ DialogConstant.EDIT_QUESTION_DIALOG_BODY }}
      </div>
    </template>
    <template #dialog-footer>
      <jha-button
        appearance="primary"
        @click="showDialog = false"
        class="btn-gap"
        >Never mind</jha-button
      >
      <jha-button
        default
        appearance="secondary"
        @click="onConfirmEditQuestion"
        >Yes, proceed</jha-button
      >
    </template>
  </blt-modal-dialog>
</template>

<style scoped>
.checkbox-full-width {
  width: 100%;
}

.enroll-cip-heading {
  background: var(--jha-background-color, #edeeef);
  padding: var(--jh-space-200);
  margin-bottom: var(--jh-space-400);
  margin-right: var(--jh-space-600);
}
.dialog-content {
  padding: var(--jh-space-500);
}
.spacing-small {
  padding-bottom: var(--jh-space-50);
  width: 100%;
}

.enroll-cip {
  padding-bottom: var(--jh-space-600);
  --jha-select-text-size: 14px;
  --jha-select-text: var(--body-text-secondary-color);
  /* padding-right: var(--jh-space-600); */
}
.enroll-cip:last-child {
  padding-bottom: var(--jh-space-600);
}

.cip-answer {
  padding-top: var(--jh-space-200);
  padding-right: var(--jh-space-600);
  padding-left: var(--jh-space-500);
}

.cip-question {
  padding-right: var(--jh-space-600);
}

.cip-questions {
  padding-top: var(--jh-space-200);
  padding-right: var(--jh-space-600);
}

.cip-questions:first-child {
  padding-top: var(--jh-space-400);
}

.cip-ques {
  min-height: 100px;
}

.cip-dropdown {
  margin-bottom: var(--jh-space-300);
  padding-top: 4px !important;
}
.cip-dropdown-ans {
  padding-top: var(--jh-space-200) !important;
}

.edit-answer {
  padding: 0px;
  cursor: pointer;
}
.btn-gap {
  margin-right: var(--jh-space-300);
}
.enroll-cip-head-content {
  padding-left: var(--jh-space-400);
}
.answer,
.dollar-sign {
  color: var(--body-text-secondary-color);
}

.content-padding {
  font-size: 14px;
  font-weight: 500;
  padding-bottom: var(--jh-space-400);
  padding-top: var(--jh-space-100);
}
.choice-icon {
  vertical-align: bottom;
  margin-left: -24px;
}
.jh-icon-pos {
  vertical-align: middle;
  margin-top: -24px;
}
.current-app {
  padding-left: var(--jh-space-1000);
}
.divider {
  margin-bottom: 0px !important;
  /* padding-top: var(--jh-space-200) !important; */
}
div > jha-button {
  --jha-button-font-weight: 500;
}
.question-bank {
  padding-bottom: var(--jh-space-400);
}

.ques-ans {
  padding-bottom: var(--jh-space-200);
}
.choice-text {
  padding-left: var(--jh-space-200);
  width: 100%;
}
:deep(.footer-content) {
  padding-top: 0;
}
@media (max-width: 599px) {
  .cip-questions,
  .cip-question {
    padding-right: var(--jh-space-400);
  }
  .cip-answer {
    padding-right: var(--jh-space-400);
  }
}
</style>
